<div [class]="data.modoBanner ? 'content' : 'content-pesquisa'">
  <h3 class="icon-title">
    <span class="title-alert">{{titulo}}</span>
  </h3>
  <mat-dialog-content class="mat-typography">
    <ng-container *ngIf="data.fotoPath && data.modoBanner">
      <img [src]="data.fotoPath" style="cursor: pointer"
           alt="Convite Webinar gratuito soluções de logística de entrega"
           (click)="redirecionarPara(link.url)">
    </ng-container>
    <a *ngIf="(!data.fotoPath && data.modoBanner)"
      [href]="link.url"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="assets/img/icons/opiniao.png" alt="Link de pesquisa"> Acessar formulário de pesquisa
    </a>

  </mat-dialog-content>

  <mat-checkbox [(ngModel)]="naoMostrarNovamente" style="margin-top: 50px" *ngIf="data.podeDesativar">
    Não mostrar novamente
  </mat-checkbox>
  <mat-dialog-actions class="mt-2 mat-dialog-actions">
    <button mat-raised-button color="warn" (click)="fechar()">
      <mat-icon>close</mat-icon>
      Fechar
    </button>
  </mat-dialog-actions>
</div>
